import styled from 'styled-components';

export const DictationActions = styled.div.attrs({
  className: 'flex items-center gap-1',
})``;

export const AudioLevelIndicator = styled.div.attrs({
  'aria-label': 'Input level',
  title: 'Input level',
  className: 'flex items-end h-4 w-6 gap-[2px]',
})``;

export const AudioBar = styled.span.attrs({
  className: 'w-[3px] bg-success rounded-sm',
})``;

export const MicButton = styled.button.attrs({
  type: 'button',
  tabIndex: -1,
  className:
    'flex h-6 w-6 items-center justify-center rounded-md text-muted-foreground hover:bg-vantis-pastelblue hover:text-foreground disabled:opacity-40',
})``;

export const MicOffButton = styled.button.attrs({
  type: 'button',
  tabIndex: -1,
  className: 'flex h-6 w-6 items-center justify-center rounded-md text-red-600 hover:text-red-700',
})``;
